import { apiFetch } from "./api";

export interface DashboardTasksDto { openCount: number; overdueCount: number; }
export interface DashboardQuotesDto { awaitingApproval: number; expiringSoon: number; openTotal: number; }
export interface DashboardJobsDto { inProductionStage: number; awaitingArtwork: number; awaitingApproval: number; }
export interface DashboardInvoicesDto { overdueCount: number; totalOutstanding: number; }

export const dashboardApi = {
  myTasks: (): Promise<DashboardTasksDto> => apiFetch<DashboardTasksDto>("/api/dashboard/my-tasks"),
  quotes: (): Promise<DashboardQuotesDto> => apiFetch<DashboardQuotesDto>("/api/dashboard/quotes"),
  jobs: (): Promise<DashboardJobsDto> => apiFetch<DashboardJobsDto>("/api/dashboard/jobs"),
  invoices: (): Promise<DashboardInvoicesDto> => apiFetch<DashboardInvoicesDto>("/api/dashboard/invoices"),
};
